export enum TransactionStatus {
  None = 0,
  InProgress = 1,
  Complete = 2,
}

// tslint:disable-next-line:no-namespace
export namespace TransactionStatus {
  export function toString(transactionStatus: TransactionStatus): string {
    switch (transactionStatus) {
      case TransactionStatus.InProgress:
        return `In Progress`;
      case TransactionStatus.Complete:
        return 'Completed';
      case TransactionStatus.None:
      default:
        return `Unavailable`;
    }
}
}
